import React, { useState } from "react"
import { Tabs } from "../../components/Tabs"
import { AssistanceList, AssistanceToResolveList } from "../../components/ListView"
import { ChatIcon } from "../../components/ImageComponents"
import LogosBanner from "../../components/LogosBanner"
import "./styles.scss"
import { PickerWithType } from "../../components/DatePicker"
import { Input, SelectInput } from "../../components/Form"
import CardHeader from "../../components/CardHeader"
import { Button, ButtonActions, ButtonLoader } from "../../components/Button"
import { isMobile } from "react-device-detect"
import CustomTreeSelect from "../../components/TreeSelect"
import { TaskTableContainer } from "../../container/ActionPlanTaskTableContainer"
import { IoFilterOutline } from "react-icons/io5"
import { useLocation } from "react-router-dom"
import { SectorAutomationContainer } from "../../container/SectorAutomationContainer"
import SendMagicLinkContainer from "../../container/SendMagicLinkContainer"
import TagContainer from "../../container/TagContainer"
import MessageNewsContainer from "../../container/MessageNewsContainer"
import MessageContainer from "../../container/MessageContainer"
import { useChatContext } from "../../core/context/chatContext"
import ActionsAssistanceContainer from "../../container/SelectActionUsersContainer"
import { ModalBody, ModalHeader, ModalPanel } from "../../components/Modal"
import { SendTermsOfUseContainer } from "../../container/SendTermsOfUseContainer"
import { ActionsMenu } from "../../components/ActionsMenu"
import Overlay from "../../components/Overlay"
import { isObjectEffectivelyEmpty } from "../../components/NewChatComponents"

const ActionsModal = ({
  selectedUserId,
  pinnedMessages,
  sectorModalIsOpen,
  setSectorModalIsOpen,
  messageModalIsOpen,
  setMessageModalIsOpen,
  modalNewsIsOpen,
  setModalNewsIsOpen,
  modalTermsIsOpen,
  setModalTermsIsOpen,
  modalMagicLinkIsOpen,
  setModalMagicLinkIsOpen,
  tagLinkIsOpen,
  setModalTagLinkIsOpen,
}) => {
  const { isScheduleOpen, handleOpenSchedule, handleCloseSchedule } = useChatContext()
  const setModalIsOpen = (open) => (open ? handleOpenSchedule(open) : handleCloseSchedule())

  return (
    <>
      <SectorAutomationContainer
        isChatContainer={true}
        selectedsUsers={[selectedUserId]}
        setSectorModalIsOpen={setSectorModalIsOpen || setModalIsOpen}
        sectorModalIsOpen={sectorModalIsOpen || isScheduleOpen}
        pinnedMessages={pinnedMessages}
      />
      {messageModalIsOpen && (
        <MessageContainer
          isChatContainer={true}
          setMessageModalIsOpen={setMessageModalIsOpen}
          messageModalIsOpen={messageModalIsOpen}
          selectedsUsers={[selectedUserId]}
        />
      )}
      {modalNewsIsOpen && (
        <MessageNewsContainer
          selectedsUsers={[selectedUserId]}
          setModalNewsIsOpen={setModalNewsIsOpen}
          modalNewsIsOpen={modalNewsIsOpen}
        />
      )}
      {modalTermsIsOpen && (
        <SendTermsOfUseContainer
          modalTermsIsOpen={modalTermsIsOpen}
          setModalTermsIsOpen={setModalTermsIsOpen}
          isChatContainer={true}
          selectedUsers={[selectedUserId]}
        />
      )}
      {modalMagicLinkIsOpen && (
        <SendMagicLinkContainer
          setModalMagicLinkIsOpen={setModalMagicLinkIsOpen}
          modalMagicLinkIsOpen={modalMagicLinkIsOpen}
          selectedsUsers={[selectedUserId]}
        />
      )}
      {tagLinkIsOpen && (
        <TagContainer
          users={[selectedUserId]}
          isChatContainer={true}
          tagIsOpen={tagLinkIsOpen}
          setTagIsOpen={setModalTagLinkIsOpen}
        />
      )}
    </>
  )
}

const NewAssistanceScreen = ({
  appointmentsData,
  listData,
  handleChangeTab,
  numberOfOpen,
  numberOfClose,
  goToScheduleDetails,
  goToAssistanceDetails,
  onChange,
  goToGetLink,
  treeData,
  handleChangeTree,
  handleChangeTecnhicianSelect,
  technicianOptions,
  tagPossibility,
  setTagPossibility,
  changeFilter,
  filter,
  uniqueEmails,
  data,
  handleProjectsPeriodFilter,
  isAdminOrManagerUser,
  handleShowFilters,
  showFilters,
  startPageFilters,
  loadingActionPlan,
  exportPlan,
  saveReload,
  handleSelectUser,
  handleFetchFilters,
  selectedUserId,
  loadingAppointments,
  loadingOpenedOrFinished,
  isRefetchingAppointmentsData,
  resetStartPageFilters
}) => {

  const {
    handleOpenSchedule,
    handleOpenAssistance,
    handleOpenChatScreen,
  } = useChatContext()

  const hasTaskData = (data && data.length > 0)
  const hasListNexts = (appointmentsData && appointmentsData.length > 0)
  const shouldShowFilters = (!hasTaskData && !hasListNexts) || showFilters
  const isFull = false
  const [modalNewsIsOpen, setModalNewsIsOpen] = useState(false)
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false)
  const [tagLinkIsOpen, setModalTagLinkIsOpen] = useState(false)
  const generateMenuItem = (label, onClick) => {
    return {
      label,
      onClick,
    }
  }

  const options = [
    generateMenuItem("Iniciar conversa", () => handleOpenChatScreen(selectedUserId?.id)),
    generateMenuItem("Enviar Conteúdo", () => setModalNewsIsOpen(true)),
    generateMenuItem("Agendar Atendimento", () => handleOpenSchedule(true)),
    generateMenuItem("Registrar Atendimento", () => handleOpenAssistance(selectedUserId, true)),
    generateMenuItem("Enviar Formulário", () => setModalTermsIsOpen(true)),
    generateMenuItem("Vincular tag", () => setModalTagLinkIsOpen(true)),
  ].filter(Boolean);

  return (
    <>
      <Overlay loading={isRefetchingAppointmentsData} />
      <div
        className={
          isAdminOrManagerUser && showFilters
            ? `assistance__container assistance__container--with-period ${isFull ? "full" : ""}`
            : `assistance__container assistance__container--no-period ${isFull ? "full" : ""}`
        }>
        <div className="assistance-period-card">
          <div className="assistance-period-card-title">
            <CardHeader title="Atendimentos" className="last-assistance-header" />
            <CardHeader className="last-assistance-header">
              <>
                <div className="mobile-only">
                  <ButtonActions handleClick={goToGetLink} />
                </div>
                <div className="filter-button-container" onClick={() => handleShowFilters()}>
                  <IoFilterOutline className="icon-filter" />
                  <text className="text-filter">Filtrar</text>
                </div>
                <div className="actions-menu">
                  <ActionsMenu options={options} isDisabled={!selectedUserId?.id} messageActionButton={!selectedUserId?.id ? `Selecione um usuário` : `Ações disponíveis`} />
                </div>
              </>
            </CardHeader>
          </div>
          <Input
            placeholder="Pesquise pelo nome"
            hasIcon={<i className="fi fi-rr-search"></i>}
            hasFocus={false}
            value={startPageFilters?.search || ""}
            onChange={(event) => onChange("search", event?.target?.value)}
          />
          {shouldShowFilters && (
            <div
              className="period-header__group-form"
              style={
                isFull
                  ? {
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    width: "100%",
                  }
                  : {}
              }>
              <div className="header-period" style={{ flex: 1 }}>
                <span className="period-header-label">Projeto/Organização</span>
                <CustomTreeSelect
                  treeData={treeData}
                  value={startPageFilters?.project || ""}
                  placeholder="Selecione o projeto, empresa ou organização"
                  handleChange={handleChangeTree}
                  width="100%"
                />
              </div>
              <div className="header-period" style={{ flex: 1 }}>
                <span className="period-header-label">Período</span>
                <PickerWithType
                  onChange={handleProjectsPeriodFilter}
                  value={startPageFilters?.period || ""}
                  isWhite={false}
                />
              </div>

              {isAdminOrManagerUser && (
                <div className="header-period" style={{ flex: 1 }}>
                  <span className="period-header-label">Técnico</span>
                  <SelectInput
                    handleChange={handleChangeTecnhicianSelect}
                    value={startPageFilters?.technician || ""}
                    isMulti
                    options={technicianOptions || []}
                    resetFields={!startPageFilters?.technician?.length && startPageFilters?.project == null}
                    isDisabled={!technicianOptions}
                    isSearchable={true}
                    maxHeight={55}
                    className="tecnhinican-select"
                  />
                </div>
              )}

              <div className="start-page-reset-buttons">
                <Button label="Limpar filtros" variant="outline" color="orange" handleClick={() => resetStartPageFilters()} isDisabled={isObjectEffectivelyEmpty(startPageFilters)} />
                <ButtonLoader
                  label="Buscar"
                  messageProcess="Buscando..."
                  loading={loadingAppointments || loadingOpenedOrFinished || isRefetchingAppointmentsData}
                  color="orange"
                  handleClick={() => handleFetchFilters()}
                />
              </div>
            </div>
          )}
        </div>
        <div className={`open-closed-assistance-list ${isFull ? "full-height" : ""}`}>
          <Tabs
            options={[
              {
                value: 1,
                label: !isMobile ? `Aberto (${numberOfOpen})` : "Aberto",
              },
              {
                value: 2,
                label: !isMobile ? `Fechado (${numberOfClose})` : "Fechado",
              },
            ]}
            goTo={handleChangeTab}
            defaulValue={{ value: 1, label: `Aberto (${numberOfOpen})` }}
          />
          <AssistanceList
            listData={Array.isArray(listData) ? listData : []}
            handleClick={goToAssistanceDetails}
            onChangeSelectedId={handleSelectUser}
            selectedId={selectedUserId}
          />
        </div>
        <div className="last-assistance__section">
          {appointmentsData && appointmentsData.length > 0 && (
            <>
              <CardHeader title="Próximos atendimentos" className="last-assistance-header">
                <h2 className="header__container-title">{appointmentsData.length}</h2>
              </CardHeader>
              <div className="last-assistance__section-horizontal-cards">
                <AssistanceToResolveList
                  loadingAppointments={loadingAppointments}
                  appointmentsData={appointmentsData || []}
                  handleClick={goToScheduleDetails}
                />
              </div>
            </>
          )}
          {(
            <>
              <CardHeader title="Plano de ação" className="last-assistance-header">
                <h2 className="header__container-title">{data.length}</h2>
              </CardHeader>

              <TaskTableContainer
                {...{
                  data,
                  tagPossibility,
                  loadingActionPlan,
                  uniqueEmails,
                  setTagPossibility,
                  exportPlan,
                  // isAssistanceScreen: true,
                  changeFilter,
                  filter,
                  reload: saveReload
                }}
              />
            </>
          )}
        </div>
      </div>
      <ActionsModal
        {...{
          selectedUserId,
          pinnedMessages: [],
          modalNewsIsOpen,
          setModalNewsIsOpen,
          modalTermsIsOpen,
          setModalTermsIsOpen,
          tagLinkIsOpen,
          setModalTagLinkIsOpen,
        }}
      />
      <ActionsAssistanceContainer user={selectedUserId} originPath="initial" />
    </>
  )
}

export default NewAssistanceScreen
